import { render, staticRenderFns } from "./MemberDesignation.vue?vue&type=template&id=0eadb1ce"
import script from "./MemberDesignation.vue?vue&type=script&lang=js"
export * from "./MemberDesignation.vue?vue&type=script&lang=js"
import style0 from "./MemberDesignation.vue?vue&type=style&index=0&id=0eadb1ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports